import MainLayout from "@/components/layout/MainLayout.vue";
import Pagination from 'laravel-vue-pagination';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import axios from "axios";
import store from "@/store";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import CONFIG from "@/assets/js/config.js";

const convertNumberService = new ConvertNumService();

export default {
  name: "manageAssignment",

  components: {
    MainLayout,
    Pagination,
    DatePicker,
    AdvancedLaravelVuePaginate,
  },

  data() {
    return {
      keyword: "",
      class_type: 0,
      search_date: "",
      assignments: {},
      pg_status: false,
      lastPage: "",
      currentPage: "",
      CONFIG,
      date_invalid_error: false,
      totalAns: '',
      currentEngPage: ''
    };
  },

  computed: {
    ...mapGetters(["teacherId", "schoolId", "userType"]),
  },

  methods: {
    search(page = 1) {
      axios.get("my/assignment/list/search?page=" + page, {
        params: {
          keyword: this.keyword,
          search_date: this.search_date,
          class_type: this.class_type ?? ''
        }
      })
        .then((response) => {
          this.pg_status = true
          this.totalAns = response.data.total;
          this.currentEngPage = response.data.current_page;
          this.assignments = response.data;
          this.assignments.total = convertNumberService.convertEng2Mm(this.assignments.total);
          this.lastPage = convertNumberService.convertEng2Mm(this.assignments.last_page);
          this.currentPage = convertNumberService.convertEng2Mm(this.assignments.current_page);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("Course Search Manage Class API Error", error);
        });
    },

    getAssingmentList(page = 1) {
      axios.get("/my/assignment/list?page=" + page)
        .then((response) => {
          this.totalAns = response.data.total;
          this.currentEngPage = response.data.current_page;
          this.assignments = response.data;
          this.assignments.total = convertNumberService.convertEng2Mm(this.assignments.total);
          this.lastPage = convertNumberService.convertEng2Mm(this.assignments.last_page);
          this.currentPage = convertNumberService.convertEng2Mm(this.assignments.current_page);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("Manage Assignment API Error", error);
        });
    },

    confirmDelete(assignmentId) {
      const confirmed = window.confirm('ဤ Assignment ကို ဖျက်ရန် သေချာပါသလား?');
      if (confirmed) {
        this.assignmentDelete(assignmentId);
      }
    },

    notificationCount() {
      var id = null;
      var type = this.userType;
      if (this.teacherId) {
        id = this.teacherId;
      }
      if (this.studentId) {
        id = this.studentId;
      }
      axios.get("my/notification/count", {
        params: {
          id: id,
          type: type
        }
      })
        .then(response => {
          store.commit("setNotificationCount", response.data);
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log(error, "error");
        });
    },

    assignmentDelete(assignmentId) {
      axios.delete("/my/assignment/delete/" + assignmentId)
        .then(response => {
          if (response.status === 200) {
            this.$notification.success("Assignment ဖျက်ခြင်းအောင်မြင်ပါသည်။", {
              timer: 3,
              position: "bottomCenter"
            });
            let newPage = this.currentEngPage;
            const remainItem = this.totalAns - 1;
            const itemPerPage = 10;
            const maxPage = Math.ceil(remainItem / itemPerPage);

            if (newPage > maxPage) {
              newPage = maxPage > 0 ? maxPage : 1;
            }
            this.getAssingmentList(newPage);
          } else {
            this.$notification.success("Assignment ဖျက်ခြင်းမအောင်မြင်ပါ။", {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          } else if (error.response && error.response.status == 422) {
            if (error.response.data == 'Student answer exists!') {
              this.$notification.error("ဖျက်မရပါ! အဖြေများ ရှိနေသည်။", {
                timer: 4,
                position: "bottomCenter"
              });
            } else {
              this.$notification.error("Assignment ဖျက်ခြင်းမအောင်မြင်ပါ။", {
                timer: 3,
                position: "bottomCenter"
              });
            }
          } else {
            console.log("Manage Assignment API Error", error);
          }
        });
    },
  },

  filters: {
    truncateAssignmentName(name) {
      return name.length < 20 ? name : name.substring(0, 20) + '...';
    }
  },

  mounted() {
    this.getAssingmentList();
  }
}
